import { RefObject, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import Icon from '@components/icons/Icon';
import styles from '@components/CustomizeIcon/CustomizeIcon.styles';
import theme from '@styles/theme';
type PropsType = {
  hoverRef: RefObject<HTMLElement | null>;
  background?: string;
  /** Hover całej karty — ten sam stan co najechanie na sam przycisk (rozszerzenie, obramowanie). */
  isCardHovered?: boolean;
};
const CustomizeIcon = ({
  hoverRef,
  background = theme.rawColors.neutralWhite,
  isCardHovered = false
}: PropsType) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    t
  } = useTranslation('common');
  const onEnter = () => {
    setIsHovered(true);
  };
  const onLeave = () => {
    setIsHovered(false);
  };
  useEffect(() => {
    const hoverElement = hoverRef.current;
    if (hoverElement) {
      hoverElement.addEventListener('mouseenter', onEnter);
      hoverElement.addEventListener('mouseleave', onLeave);
      return () => {
        hoverElement.removeEventListener('mouseenter', onEnter);
        hoverElement.removeEventListener('mouseleave', onLeave);
      };
    }
    return () => null;
  }, [hoverRef]);
  const memorizedIcon = useMemo(() => <Icon icon="FilterUnselected" size="18px" />, []);
  const isActive = isHovered || isCardHovered;
  return <span sx={styles.customizeIconBox(isActive, background)} aria-hidden="true">
      {memorizedIcon}
      <p>{t('customize')}</p>
    </span>;
};
export default CustomizeIcon;